import { makeSx } from '@saas/lib/shared-utils'
import { palette } from '../../../utilities'

export default makeSx({
    tooltip: {
        display: 'flex',
        minWidth: '17rem',
        maxWidth: '24.625rem',
        padding: '1rem',
        backgroundColor: palette.typography['900'],
        color: palette.typography['100'],
        fontWeight: 600,
        fontSize: '0.875rem',
        lineHeight: '1.375rem',
        letterSpacing: '0.17px',
        border: 'none',
    },
    tooltipArrow: {
        color: palette.typography['900'],
    },
})
